export default __webpack_public_path__ + "static/media/skateboard.ecf589ae.png";